import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Logo } from '../../components/Logo/Logo';

const ButtonWrapper = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    border-radius: 30px;
    margin: 0.5em;
    border-style: none;
    background: ${props => props.background === 'light' ? '#3fa9b4' : '#2C7880'};
    color: white;
    height: 50px;
    width: 180px;
`

const ProviderProfileButton = ({background, onClick, profilePhotoURL, text}) => {
    return(
        <ButtonWrapper
            onClick={onClick}
            background={background}
        >
            <Logo 
                logoURL={profilePhotoURL}
                size={30}
                style={{
                    display:'inline-block',
                    float:'left',
                    marginLeft:'inherit'
                }} 
            />
            {text}
        </ButtonWrapper>
            
    )
}

ProviderProfileButton.defaultProps = {
    background: 'light',
    onClick: () => null,
    profilePic: null,
    text: 'Placeholder text'
}

export default ProviderProfileButton;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/ProviderProfileButton.jsx